import { useEffect, useRef } from 'react';
import { track } from './analytics.js';

// IDs come from the actual gated reader item, never arbitrary query/form text.
export function useBetaContent(packId, itemId, view = 'section', ready = true) {
    const previous = useRef(null);
    useEffect(() => {
        if (!ready || !packId || !itemId) return undefined;
        const key = JSON.stringify([packId, itemId, view]);
        const record = () => {
            if (previous.current === key) return;
            if (track('btl_content_open', { pack_id: packId, content_id: itemId, reader_view: view })) previous.current = key;
        };
        record();
        // The auth barrier or consent choice may resolve after the reader mounts.
        window.addEventListener('btl-analytics-ready', record);
        return () => window.removeEventListener('btl-analytics-ready', record);
    }, [packId, itemId, view, ready]);
}
